import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Account } from 'app/entities/account';
import { User } from 'app/entities/user';
import { LocalStorageService } from 'app/services/local-storage.service';
import { selectAccount } from 'app/state/account/account.selectors';
import { selectUser } from 'app/state/user/user.select';

@Injectable({
    providedIn: 'root'
})
export class ProductsListSearchStateService {
    private readonly storageKeyPrefix = 'products.list.search';
    private accountId: number | null = null;
    private userId: number | null = null;

    constructor(
        private _localStorageService: LocalStorageService,
        private _store: Store
    ) {
        this._store.select(selectAccount).subscribe((account: Account | null) => {
            this.accountId = account?.id ?? this.accountId;
        });

        this._store.select(selectUser).subscribe((user: User | null) => {
            this.userId = user?.id ?? this.userId;
            this.accountId = user?.account?.id ?? this.accountId;
        });
    }

    getSearch(): string {
        const storageKey = this.getStorageKey();

        if (!storageKey) {
            return '';
        }

        return this._localStorageService.getItem(storageKey, '');
    }

    setSearch(search: string | null | undefined): void {
        const storageKey = this.getStorageKey();

        if (!storageKey) {
            return;
        }

        if (!search) {
            this._localStorageService.removeItem(storageKey);
            return;
        }

        this._localStorageService.setItem(storageKey, search);
    }

    clear(): void {
        const storageKey = this.getStorageKey();

        if (storageKey) {
            this._localStorageService.removeItem(storageKey);
        }
    }

    clearAll(): void {
        const keysToRemove: string[] = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);

            if (key?.startsWith(`${this.storageKeyPrefix}.`)) {
                keysToRemove.push(key);
            }
        }

        this._localStorageService.removeItem(...keysToRemove);
    }

    private getStorageKey(): string | null {
        if (this.accountId) {
            return `${this.storageKeyPrefix}.account.${this.accountId}`;
        }

        if (this.userId) {
            return `${this.storageKeyPrefix}.user.${this.userId}`;
        }

        return null;
    }
}
